import { type Group, type Organization, Status } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import { Stack } from "@mui/material";
import PhoneNumberCell from "../PhoneNumberCell";

export const useGroupColumns = (currOrganization: Organization, setAlertText: any, setSeverity: any): ColumnProps<Group>[] => {
  return [
    {
      field: "name",
      enableSorting: true,
      minSize: 250
    },
    {
      field: "admin",
      minSize: 250,
      cell: ({ row }) => (
        <Stack alignItems="flex-start" flexDirection="column">
          <div>
            <strong>שם:</strong> {row.original.admin?.name}
          </div>
          <div>
            <strong>מספר טלפון:</strong>
            {" "}
            <PhoneNumberCell phoneNumber={row.original.admin?.phoneNumber || ""} />
          </div>
          <div>
            <strong>מייל:</strong> {row.original.admin?.email}
          </div>
        </Stack>
      ),
    },
    { field: "description" },
    { field: "size" },
    { field: "comments" },
  ];
};